import { Component, OnInit } from '@angular/core';
import {FormGroup, FormControl, FormBuilder, NgForm, Validators,FormArray } from '@angular/forms';
import {PredictionserviceService} from '../predictionservice.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-heart',
  templateUrl: './heart.component.html',
  styleUrls: ['./heart.component.css'],
  providers:[PredictionserviceService],
})
export class HeartComponent implements OnInit {

  constructor(private router:Router,private fb: FormBuilder,private serv:PredictionserviceService) { }
  cpt:number[]=[0,1,2,3];
  fbsa:number[]=[0,1];
  caa:number[]=[0,1,2,3,4];
  restecga:number[]=[0,1,2];
  gen:string[]=["male","female"];
  predictForm:FormGroup
  user=JSON.parse(localStorage.getItem('loginUser'));
  ngOnInit(): void {

    this.predictForm=this.fb.group({
      sex:[this.user.gender,[Validators.required]],
      age:[this.user.age,[Validators.required,Validators.min(10),Validators.max(100)]],
      thestbps:[null,[Validators.required,Validators.min(50),Validators.max(250)]],
      cp:[null,[Validators.required]],
      chol:[null,[Validators.required,Validators.min(100),Validators.max(650)]],
      fbs:[null,[Validators.required]],
      restecg:[null,[Validators.required]],
      thalach:[null,[Validators.required,Validators.min(40),Validators.max(400)]],
      oldpeak:[null,[Validators.required,Validators.min(0),Validators.max(10)]],
      exang:[null,[Validators.required]],
      ca:[null,[Validators.required]],
      slope:[null,[Validators.required]],
      thal:[null,[Validators.required]],
    })
  }
  predict:any;
  pre:any;
  submit(){
    console.log("Data is submitted");
    console.log(this.predictForm.controls.value);
    this.predict={
      thal:this.predictForm.controls.thal.value,
      slope:this.predictForm.controls.slope.value,
      ca:this.predictForm.controls.ca.value,
      exang:this.predictForm.controls.exang.value,
      oldpeak:this.predictForm.controls.oldpeak.value,
      thalach:this.predictForm.controls.thalach.value,
      restecg:this.predictForm.controls.restecg.value,
      fbs:this.predictForm.controls.fbs.value,
      chol:this.predictForm.controls.chol.value,
      cp:this.predictForm.controls.cp.value,
      thestbps:this.predictForm.controls.thestbps.value,
      age:this.predictForm.controls.age.value,
      sex:this.predictForm.controls.sex.value,
    };
    if (this.predict.sex==2){
      this.predict.sex=0;
    }
    console.log(this.predict);
    this.serv.userPrediction(this.predict).subscribe(
      data=>{
        console.log("data is posted");
        this.pre=data.Survived[0];
        localStorage.setItem('pre',this.pre);
        console.log(data.Survived);
        console.log("Value:- ",this.pre);
        this.router.navigate(['/user/prediction']);
      },
      error=>{
        console.log("ERROR");
      }
    );
    console.log("Value:- ",this.pre);
  }
}
